import { defineStore } from 'pinia'
import { reactive } from 'vue'

export const useDeskStore = defineStore('desk', () => {
  const desk = reactive({
    lineColor: '#000000'
  })

  const setColor = (val: string) => {
    desk.lineColor = val
  }

  return {
    desk, setColor
  }
}, {
  persist: true
})